import {
	MailOutlineRounded,
	MenuRounded,
	NotificationsNoneRounded,
} from '@mui/icons-material';
import { Avatar, Badge, ButtonGroup, IconButton } from '@mui/material';
import './Navbar.css';

const NavBar = ({
	active,
	setSideBarActive,
}: {
	active: boolean;
	setSideBarActive: any;
}) => {
	return (
		<div className='navbar'>
			<IconButton onClick={() => setSideBarActive(!active)}>
				<MenuRounded />
			</IconButton>

			<div className='flex items-center space-x-3'>
				<ButtonGroup className='space-x-3'>
					<IconButton size='large'>
						<Badge variant="dot" color='primary'>
							<MailOutlineRounded />
						</Badge>
					</IconButton>
					<IconButton size='large'>
						<Badge variant="dot" color='warning'>
							<NotificationsNoneRounded />
						</Badge>
					</IconButton>
				</ButtonGroup>

				<div className='flex space-2-3'>
					<IconButton>
						<Avatar />
					</IconButton>
					<div className='flex flex-col items-start justify-center'>
						<span>Muhammed Elfeqy</span>
						<span>Developer</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default NavBar;
